module.exports = __webpack_public_path__ + "img/duanwu_ps_05.cab7ae0c.jpg";